import firebase from "../../config/firebase";
import {
  COLLECTION_BOOKING_PACKAGE,
  COLLECTION_CUSTOMER14860,
  COLLECTION_CUSTOMERCOUPON37856,
  COLLECTION_CUSTOMERFAVORITES,
} from "./firebaseConstants";
import { collectionWithArgs, db } from "./firestoreService";

export interface ICustomerProfileUpdate {
  name?: string;
  surname?: string;
  nameAndSurname?: string;
  email?: string;
  phone?: string;
  secondaryPhone?: string;
  iDPassportNumber?: string;
  dateOfBirth?: Date | null;
  newsletterOptIn?: boolean;
}

const withCustomerFilter = (
  ref: firebase.firestore.Query,
  customerId: string,
  extraArgs: any[] = [],
) => {
  if (!customerId) return null;
  return collectionWithArgs(ref, [
    {
      type: "filter",
      name: "customerId",
      opr: "==",
      value: customerId,
    },
    ...extraArgs,
  ]);
};

export function fetchCustomerBookingsFromFirestore(customerId: string) {
  const ref = db.collection(COLLECTION_BOOKING_PACKAGE);
  return withCustomerFilter(ref, customerId, [
    {
      type: "sorting",
      name: "bookingDate",
      opr: "desc",
      order: "desc",
    },
  ]);
}

export function fetchCustomerFavoritesFromFirestore(customerId: string) {
  const ref = db.collection(COLLECTION_CUSTOMERFAVORITES);
  return withCustomerFilter(ref, customerId);
}

export function fetchCustomerCouponsFromFirestore(customerId: string) {
  const ref = db.collection(COLLECTION_CUSTOMERCOUPON37856);
  return withCustomerFilter(ref, customerId, [
    {
      type: "sorting",
      name: "startDate",
      opr: "desc",
      order: "desc",
    },
  ]);
}

export function updateCustomerProfileInFirestore(
  customerId: string,
  payload: ICustomerProfileUpdate,
) {
  const docRef = db.collection(COLLECTION_CUSTOMER14860).doc(customerId);
  const dataToUpdate: Record<string, any> = {
    ...payload,
    updateAt: firebase.firestore.FieldValue.serverTimestamp(),
  };
  if (Object.prototype.hasOwnProperty.call(payload, "dateOfBirth")) {
    if (!payload.dateOfBirth) {
      dataToUpdate.dateOfBirth = null;
    } else {
      dataToUpdate.dateOfBirth = firebase.firestore.Timestamp.fromDate(
        payload.dateOfBirth,
      );
    }
  }

  return docRef.update(dataToUpdate);
}
